import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    paragraph: p => p.accentWhite,
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    paragraph: p => p.tertiaryDark,
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    paragraph: p => p.tertiaryDark,
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
